import { render, staticRenderFns } from "./all-certificate.vue?vue&type=template&id=1fded8ee&scoped=true&"
import script from "./all-certificate.vue?vue&type=script&lang=js&"
export * from "./all-certificate.vue?vue&type=script&lang=js&"
import style0 from "./all-certificate.vue?vue&type=style&index=0&id=1fded8ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fded8ee",
  null
  
)

export default component.exports